<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  import TextContentDetail from '@/components/shared/CommonDetail.vue'

  export default {
    components: {
      TextContentDetail
    },
    computed: {
      ...mapGetters([
        'ContentPage',
        'AppConfig',
        'resource'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      ContentId() {
        return this.$f7route.params.ContentId
      },
      PostDetails() {
        let post
        for (let i = 0; i < this.ContentPage.ContentPages.length; i++) {
            post = this.ContentPage.ContentPages[i].Posts.find(a => a.Id === this.ContentId)
            if (Helper.IsValid(post)) {
                break
            }
        }
        return post
      },
      Favorite() {
        if (Helper.IsValid(this.PostDetails)) {
          this.IsFavorite = Helper.CheckIsFavorite(this.PostDetails.Id, this.PostDetails.ModulesContentPages_Id)
        }
        return this.IsFavorite
      },
      IsLike() {
        if (Helper.IsValid(this.PostDetails)) {
          this.IsLiked = Helper.convertBoolean(this.PostDetails.IsLiked)
        }
        return this.IsLiked
      },
      AllowLikes() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowLikes)
      },
      AllowAddingToFavorites() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowAddingToFavorites)
      },
      AllowSharing() {
        return Helper.convertBoolean(this.ContentPage.Parent.AllowSharing)
      }
    },
    methods: {
      ...mapActions([
        'showLoader',
        'hideLoader',
        'loadContentPagesLocalData',
        'loadContentPages',
        'setActiveCategory',
        'addUpdateLike',
        'shareInformation',
        'addMyFavorite'
      ]),
      infoDetailUrl: function(value) {
        return '/text-content-detail-view/' + this.SubscriptionModuleId + '/' + value
      },
      onLikeClick() {
        let Like = {
          ModulesContentPages_Id: this.PostDetails.ModulesContentPages_Id,
          Reference_Id: this.PostDetails.Id,
          Liked: !Helper.convertBoolean(this.PostDetails.IsLiked),
          AppGUID: this.AppConfig.AppGUID,
          ContentType: 1,
          NotificationContent: {
            Title: this.PostDetails.Title,
            ImageName: this.PostDetails.PostImage,
            Comment: '',
            Navigationurl: this.infoDetailUrl(this.PostDetails.Id)
          }
        }
        this.addUpdateLike(Like).then(() => {
          this.$f7.notification.create({
            title: Helper.convertBoolean(this.PostDetails.IsLiked) ? this.resource.likeSuccesTitle : this.resource.disLikeSuccesTitle,
            subtitle: Helper.convertBoolean(this.PostDetails.IsLiked) ? this.resource.likeSuccesMessage : this.resource.disLikeSuccesMessage,
            cssClass: 'success-notification',
            closeOnClick: true,
            closeTimeout: 3000
          }).open()
        })
      },
      onShareCLick() {
        let Options = {
          appConfig: this.AppConfig,
          moduleId: this.ContentPage.Parent.Module_Id,
          subscriptionModuleId: this.ContentPage.Parent.SubscriptionModule_Id,
          shareId: this.PostDetails.Id,
          path: Helper.CurrentlocationURL(),
          orderId: 0
        };
        this.shareInformation(Options);
      },
      onFavoriteClick() {
        let favData = {
          Reference_Id: this.PostDetails.Id,
          ReferenceParent_Id: this.PostDetails.ModulesContentPages_Id
        }
        this.addMyFavorite(favData)
        this.IsFavorite = Helper.CheckIsFavorite(this.PostDetails.Id, this.PostDetails.ModulesContentPages_Id)
      }
    },
    created() {
      this.$showLoader()
      if (!Helper.IsDevSim()) {
        this.loadContentPagesLocalData(this.SubscriptionModuleId)
        this.loadContentPages(this.SubscriptionModuleId).then(() => {
            this.$hideLoader()
          this.$RegisterPageView({
            'SubscriptionModule_Id': this.SubscriptionModuleId,
            'ContentGUID': this.ContentId,
            'ViewType': 2
          })
        })
      } else {
        this.$hideLoader()
      }
    },
    beforeDestroy() {
      if (Helper.IsValid(this.PostDetails)) {
        let selcat = this.PostDetails.Category
        this.setActiveCategory(selcat)
      }
    },
    data() {
      return {
        IsLiked: false,
        IsFavorite: false
      }
    }
  }
</script>
<template>
   <f7-page :page-content="false" name="text-content-detail-view" v-if="ContentPage">
    <app-header v-if="PostDetails" :header="PostDetails.Title" :isShowRightNavBar="false"></app-header>
    <app-floating-button 
      v-if="PostDetails" 
      :ShowLike="AllowLikes"
      :ShowFavorite="AllowAddingToFavorites" 
      :ShowShare="AllowSharing" 
      :IsLike="IsLike"
      :IsFavorite="Favorite" 
      :onLikeClick="onLikeClick" 
      :onFavoriteClick="onFavoriteClick" 
      :onShareCLick="onShareCLick">
    </app-floating-button>
    <div class="backgroundimg"></div>
    <text-content-detail :Parent="ContentPage.Parent" :PostDetails="PostDetails" :SubscriptionModuleId="SubscriptionModuleId" IsFrom="Content" ></text-content-detail>
  </f7-page>
</template>
<style scoped>
  .floating-button-toolbar, .speed-dial{
    bottom: 15px!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/text-content/TextContentDetail.vue